import api from './api';

export const imageService = {
  getAll: () => api.get('/site-images'),
  getByZone: (zone) => api.get(`/site-images/zone/${zone}`),
  upsert: (data) => api.post('/site-images/upsert', data),
  upload: (formData) => api.post('/site-images/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
  delete: (id) => api.delete(`/site-images/${id}`)
};
